import { format, getTime, formatDistanceToNow } from 'date-fns';
import dkLocale from 'date-fns/locale/da'; //danish
import deLocale from 'date-fns/locale/de'; //german
import enLocale from 'date-fns/locale/en-GB'; //eng
import noLocale from 'date-fns/locale/nb'; //norwegian
import seLocale from 'date-fns/locale/sv'; //swedish
import fiLocale from 'date-fns/locale/fi'; //finnish
import moment from 'moment';

// ----------------------------------------------------------------------

export function fDate(date: Date | string | number) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date: Date | string | number) {
  return format(new Date(date), 'dd MMM yyyy p');
}

export function fTimestamp(date: Date | string | number) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date: Date | string | number) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date: Date | string | number) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

export const getStartDateOfTheWeek = (weekNumber: number, year: number) => {
  const base = new Date(year, 0, 1 + (weekNumber - 1) * 7);
  const dayOfTheWeek = base.getDay();
  const ISOweekStart = base;
  if (dayOfTheWeek <= 4) {
    ISOweekStart.setDate(base.getDate() - base.getDay() + 1);
  }
  else {
    ISOweekStart.setDate(base.getDate() + 8 - base.getDay());
  }
  return ISOweekStart;
};

export const getCurrentWeekNo = (date: Date) => {
  const firstJanuary = new Date(date.getFullYear(), 0, 1);
  // @ts-ignore  
  const dayNr = Math.ceil((date - firstJanuary) / (24 * 60 * 60 * 1000));
  const weekNr = Math.ceil((dayNr + firstJanuary.getDay()) / 7) - 1;
  return weekNr;
};

export const getHamInitalStartDate = () => {
  const currentWeekNo = getCurrentWeekNo(new Date());
  const initialStartDate = getStartDateOfTheWeek(currentWeekNo, new Date().getFullYear());
  initialStartDate.setHours(0, 0, 0, 0);

  return initialStartDate;
}

export const getFormattedDayFilterDate = (date: Date, isEndDate?: boolean): string => {
  const OneDayInMilliseconds = 24 * 60 * 60 * 1000;
  const adjustedDate = new Date(date.getTime() + (isEndDate ? OneDayInMilliseconds : 0));

  const year = adjustedDate.getFullYear();
  const month = (adjustedDate.getMonth() + 1).toString().padStart(2, '0');
  const day = adjustedDate.getDate().toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const getLanguageCode = (currentLang: any) => {
  const localeMap = {
    'en': enLocale,
    'dk': dkLocale,
    'no': noLocale,
    'se': seLocale,
    'de': deLocale,
    'fi': fiLocale
  };
  // @ts-ignore  
  return localeMap[currentLang.value] || enLocale;
};

export const formatHandymanDatetimeStringToLocalDate = (datetimeString: string): string => {
  const browserLocale = navigator.language || (navigator as any).userLanguage || 'en';
  moment.locale(browserLocale);

  const m = moment(datetimeString, 'DD.MM.YYYY HH:mm:ss', true);

  if (!m.isValid()) {
    return datetimeString;
  }

  return m.format('L');
};